import { keys, head } from 'lodash';
import { react2angular } from 'react2angular';
import { compose, curriedCountBy, curriedPickBy } from '@adjust/dashboard-core/lib/fp';

/**
 * Registers the passed components with their injected dependencies into the
 * provided Angular instance and returns the module name.
 *
 * @param {Object} instance
 * @param {Array} components
 * @returns {String}
 * @impure
 */
export const registerComponents = (instance, components) => {
  const duplicated = findDuplicatedDefinitions(components);

  if (duplicated.length) {
    throw new Error(`Duplicated react2angular component definitions: ${duplicated}`);
  }

  components.forEach(([name, comp, props, deps = []]) => {
    instance.component(name, react2angular(comp, props, deps));
  });

  return instance.name;
};

/**
 * Scans the components array for duplicated definitions and returns the list
 *
 * @param {Array} components
 * @returns {[String]}
 */
export const findDuplicatedDefinitions = compose(
  keys,
  curriedPickBy(sum => sum > 1),
  curriedCountBy(head),
);
